const adminTranslation = {
  mode: 'ko',
  menu: '관리자',
  toolMenu: '도구 모음',
  billingDataMenu: 'Row data',
  billingDataRecordings: 'Recordings row data',
  billingDataBabyAi: 'BabyViewAis row data',
  billingDataDescription:
    '정산 검증에 필요한 원본 행을 기간과 고객사별로 조회하고 CSV로 내려받을 수 있습니다.',
  billingDataFilterTitle: '조회 조건',
  billingDataFilterDescription:
    '정산 월 또는 자유 기간을 선택하고 Seq·바코드·고객사·상태값으로 범위를 좁혀주세요.',
  billingDataPeriodMode: '기간 선택 방식',
  billingDataThisMonth: '이번 달',
  billingDataLastMonth: '지난달',
  billingDataBillingMonth: '정산 월 선택',
  billingDataCustomPeriod: '자유 기간',
  billingDataPeriod: '조회 기간',
  billingDataResultTitle: 'Row data 조회 결과',
  billingDataResultDescription:
    '조회 결과를 화면에서 확인하거나 현재 조건 전체를 CSV로 다운로드할 수 있습니다.',
  billingDataRecordingsNotice:
    '데일리 Recordings 시트와 동일한 필드 및 2026년 1월 1일 촬영분 이후 범위를 조회합니다. 오래된 행의 최근 상태 변경은 수정 시각을 선택해 확인하세요.',
  billingDataBabyAiNotice:
    '현재 BabyView AI 노출·과금 상태를 조회합니다. 새 행은 생성 시각, 변경된 행은 수정 시각을 선택해 확인하세요.',
  billingDataExportNotice:
    'CSV는 현재 운영 데이터를 순차 조회해 생성하며 한 번에 하나만 다운로드할 수 있습니다. 청구 확정 시에는 해당 기간 전체를 다시 대조해 주세요.',
  billingDataSeq: 'Seq',
  billingDataBarcode: '바코드',
  billingDataDevice: '기기명',
  billingDataHospital: '고객사',
  billingDataRoom: '병실',
  billingDataClientCode: '고객사 코드',
  billingDataDeleted: '삭제 여부',
  billingDataVideoLength: '영상 길이',
  billingDataRecordedAt: '촬영 시각',
  billingDataCapturedAt: '촬영 시각',
  billingDataCreatedAt: '생성 시각',
  billingDataUpdatedAt: '수정 시각',
  billingDataNet30: 'Net 30',
  billingDataVisible: '노출 여부',
  billingDataBillable: '과금 대상',
  billingDataWebhookSentAt: '웹훅 전송 시각',
  billingDataSearchLabel: 'Seq 또는 바코드',
  billingDataSearchPlaceholder: '정확한 seq 또는 바코드를 입력하세요',
  billingDataAllHospitals: '전체 고객사',
  billingDataDateBasis: '날짜 기준',
  billingDataDateRange: '날짜 범위',
  billingDataSearch: '조회',
  billingDataDownloadCsv: '현재 조건 전체 CSV',
  billingDataResultCount: '총 {{count}}건',
  billingDataDownloading: 'CSV를 다운로드하고 있습니다. 데이터가 많으면 몇 분 걸릴 수 있습니다.',
  billingDataCancelDownload: '취소',
  billingDataDownloadCancelled: 'CSV 생성을 취소했습니다.',
  billingDataDownloadStarted: 'CSV 다운로드를 시작했습니다.',
  billingDataDownloadSuccess: 'CSV 다운로드가 완료되었습니다.',
  billingDataDownloadError: 'CSV를 생성하지 못했습니다. 잠시 후 다시 시도해 주세요.',
  billingDataSearchError: '청구 데이터를 불러오지 못했습니다. 다시 시도해 주세요.',
  billingDataSearchFirst: '조회 조건을 확인하고 조회 버튼을 눌러주세요.',
  crystalRevealPromptMenu: 'Crystal Reveal 프롬프트',
  crystalRevealUsageMenu: 'Crystal Reveal 사용량',
  crystalRevealUsageTitle: 'Crystal Reveal 사용량 조회',
  crystalRevealUsageDescription:
    '선택한 기간의 실제 생성 이력을 확인하고 직전 동일 기간과 비교합니다.',
  crystalRevealUsageFilterTitle: '조회 조건',
  crystalRevealUsageFilterDescription:
    '빠른 월 또는 자유 기간과 스튜디오를 선택하고, 바코드로 원하는 세션을 찾을 수 있습니다.',
  crystalRevealUsagePeriodMode: '기간 선택 방식',
  crystalRevealUsageThisMonth: '이번 달',
  crystalRevealUsageLastMonth: '지난달',
  crystalRevealUsageBillingMonth: '정산 월 선택',
  crystalRevealUsageCustomPeriod: '자유 기간',
  crystalRevealUsagePeriod: '조회 기간',
  crystalRevealUsageStudio: '스튜디오',
  crystalRevealUsageStudioSelect: '전체 스튜디오',
  crystalRevealUsageStudios: '스튜디오 수',
  crystalRevealUsageStudiosCaption: '조회 범위',
  crystalRevealUsageSessions: '세션 수',
  crystalRevealUsageSessionsCaption: '실제 생성 세션',
  crystalRevealUsageSession: '세션',
  crystalRevealUsageRecording: '녹화',
  crystalRevealUsageCapture: '캡처',
  crystalRevealUsageComparisonPeriod: '직전 동일 기간',
  crystalRevealUsageComparisonColumn: '직전 대비',
  crystalRevealUsageComparisonLoading: '비교 중',
  crystalRevealUsageComparisonUnavailable: '비교 없음',
  crystalRevealUsageComparisonError:
    '직전 기간 사용량을 불러오지 못했습니다. 현재 기간 집계는 정상적으로 확인할 수 있습니다.',
  crystalRevealUsageNewUsage: '신규',
  crystalRevealUsageNoChange: '변화 없음',
  crystalRevealUsageSharpDrop: '급감',
  crystalRevealUsagePreviousCount: '이전 {{count}}건',
  crystalRevealUsageDifferenceCount: '증감 {{count}}건',
  crystalRevealUsageSharpDropAlert: '{{count}}개 스튜디오의 사용량이 급감했습니다.',
  crystalRevealUsageSharpDropDescription:
    '직전 동일 기간({{startDate}} ~ {{endDate}})보다 전체 생성 건수가 50% 이상 감소했습니다.',
  crystalRevealUsageSharpDropCount: '급감 {{count}}개소',
  crystalRevealUsageBarcode: '바코드',
  crystalRevealUsageBarcodeSearch: '바코드 검색',
  crystalRevealUsageBarcodeMismatch: '바코드 불일치',
  crystalRevealUsageGenerationLimitExceeded: '기준 초과',
  crystalRevealUsageGenerationLimitExceededHelp:
    'Basic 5 · Bonus 5 · Motion8K 2는 필수 생성량이 아닌 세션별 최대 생성 가능량입니다. 기준을 초과한 세션만 표시합니다.',
  crystalRevealUsageGenerationLimitExceededDetail:
    '최대 기준 대비 실제 Basic {{basic}}/5 · Bonus {{bonus}}/5 · Motion8K {{motion8k}}/2',
  crystalRevealUsageLastGeneratedAt: '마지막 생성 시각',
  crystalRevealUsageGeneratedTotal: '전체 생성 건수',
  crystalRevealUsageGeneratedCaption: '과금 집계 기준',
  crystalRevealUsageVisibleTotal: '앱 노출 건수',
  crystalRevealUsageVisibleCaption: '조회 시점 기준',
  crystalRevealUsageGeneratedGroup: '전체 생성량',
  crystalRevealUsageVisibleGroup: '앱 노출 건수',
  crystalRevealUsageTotal: '합계',
  crystalRevealUsageStudioSummary: '스튜디오 합계',
  crystalRevealUsageSessionDetail: '세션 상세',
  crystalRevealUsageResultTitle: '집계 결과',
  crystalRevealUsageResultDescription:
    '스튜디오별 합계·증감과 세션별 실제 생성량·기준 초과 여부를 확인할 수 있습니다.',
  crystalRevealUsageDownload: '스튜디오 CSV',
  crystalRevealUsageSessionDownload: '세션 상세 CSV',
  crystalRevealUsageSessionDownloadError:
    '세션 상세 CSV를 만들지 못했습니다. 잠시 후 다시 시도해 주세요.',
  crystalRevealUsageVisibleNotice:
    '앱 노출 건수는 조회 시점 기준이며 과거 시점의 상태를 보존한 값이 아닙니다.',
  crystalRevealUsageTimezoneNotice:
    '{{timezone}} 기준 {{startDate}}부터 {{endDate}}까지의 생성 이력을 집계합니다.',
  auditLogMenu: '감사 로그',
  auditLogTitle: '감사 로그',

  createTestBarcodeTitle: '테스트용 바코드 발급',
  uploadRecordingTitle: '초음파 영상 신규 업로드',
  uploadCaptureTitle: '초음파 캡쳐 업로드',

  barcode: '바코드',
  hospital: '영상 등록 병원',
  recordedAt: '영상 업로드 날짜',
  hospitalRoom: '진료실',
  selectHospitalRoom: '병실/박스 선택',
  create: '생성',
  upload: '업로드',
  uploadRecording: '영상 업로드',
  uploadCapture: '캡쳐 업로드',
  selectRecording: '영상 선택',
  selectRecordingPlaceholder: '영상을 선택해주세요',
  capturedAt: '캡쳐 시간',
  captureFile: '캡쳐 파일',

  createTestBarcode: '테스트 바코드 생성 완료',
  completeUploadRecording: '초음파 영상 업로드 완료',
  failUploadRecording: '초음파 영상 업로드 실패',
  completeUploadCapture: '초음파 캡쳐 업로드 완료',
  failUploadCapture: '초음파 캡쳐 업로드 실패',
  uploadCompleteMessage: '파일 업로드 완료, 영상 정보를 갱신 중입니다.',
  uploadFailMessage: '영상 정보 갱신 실패, 영상에 문제가 있을 수 있습니다.',
  uploadProgress: '업로드 진행률',
  uploadStatusUploading: '파일 전송 중',
  uploadStatusForwarding: '서버가 업로더로 전달 중입니다.',
  uploadStatusProcessing: '업로드 완료, 영상 정보를 갱신 중입니다.',
  uploadStatusPending: '서버 처리 중',
  uploadCanceledMessage: '업로드를 취소했습니다. 입력값은 그대로 유지됩니다.',
  cancelUpload: '업로드 취소',
  uploadTransferred: '전송량',
  uploadSpeed: '업로드 속도',
  uploadRemainingTime: '예상 남은 시간',
  uploadRemainingTimePending: '계산 불가',
  uploadElapsedTime: '경과 시간',
  hourUnit: '시간',
  minuteUnit: '분',
  secondUnit: '초',
  barcodeValidateMessage: '11자리 숫자만 입력해 주세요.',
  recordingValidateMessage: '올바른 형식의 영상 파일을 업로드해 주세요.',
  captureValidateMessage: '올바른 형식의 이미지 파일을 업로드해 주세요.',
  recordingRequiredMessage: '영상을 선택해주세요',
  capturedAtRequiredMessage: '캡쳐 시간을 선택해주세요',
  captureFileRequiredMessage: '캡쳐 파일을 업로드해주세요',
  requiredFieldsMessage: '모든 필수 필드를 입력해주세요',
  validationErrorMessage: '입력 값을 확인해주세요',
  selectRecordingDescription: '캡쳐를 업로드할 영상을 선택해주세요',
  selectedRecording: '선택된 영상',
  noRecordingsFound: '검색된 영상이 없습니다',

  excelHospital: '병원',
  excelDevice: '마미박스',
  excelRecording: '초음파 영상',
  excelCapture: '초음파 영상 캡쳐',
  googleSheetDownloadTitle: '데이터 엑셀 다운로드',
  googleSheetDownloadSelection: '엑셀 다운로드 항목',
  selectExcelType: '항목 선택',
  downloadExcel: '엑셀 다운로드',
  barcodeLabel: '바코드:',
  videoLength: '영상 길이',
  searchRecordingsErrorMessage: '영상 검색 중 오류가 발생했습니다. 다시 시도해주세요.',
};

export default adminTranslation;
